// 大埔區	大埔
// 大嶼山區	馬灣
// 	愉景灣
// 	東涌
// 	香港國際機場
// 	大嶼山
// 東區	北角
// 	柴灣
// 	筲箕灣
// 	太古
// 	鰂魚涌
// 	西灣河
// 	小西灣
// 	天后
// 	炮台山
// 	杏花邨
// 觀塘區	觀塘
// 	藍田
// 	油塘
// 	九龍灣
// 	牛頭角
// 	秀茂坪
// 	順利
// 黃大仙區	彩虹
// 	慈雲山
// 	黃大仙
// 	新蒲崗
// 	樂富
// 	鑽石山
// 	牛池灣
// 九龍城區	紅磡
// 	九龍城
// 	九龍塘
// 	馬頭圍
// 	土瓜灣
// 	何文田
// 	啟德
// 	黃埔
// 葵青區	葵涌
// 	青衣
// 	荔景
// 	葵興
// 	葵芳
// 南區	石澳
// 	赤柱
// 	大潭
// 	香港仔
// 	鴨脷洲
// 	薄扶林
// 	華富
// 	黃竹坑
// 南丫島區	南丫島
// 坪洲區	坪洲
// 荃灣區	荃灣
// 	深井
// 	大窩口
// 沙田區	沙田
// 	大圍
// 	馬鞍山
// 	火炭
// 	九肚山
// 	小瀝源
// 	石門
// 深水埗區	長沙灣
// 	荔枝角
// 	美孚
// 	石硤尾
// 	深水埗
// 	南昌
// 屯門區	屯門
// 	小欖
// 	新墟
// 	掃管笏
// 	藍地
// 灣仔區	灣仔
// 	銅鑼灣
// 	跑馬地
// 	大坑
// 西貢區	清水灣
// 	西貢
// 	調景嶺
// 	將軍澳
// 	坑口
// 	康城
// 	寶琳
// 油尖旺區	油麻地
// 	佐敦
// 	尖沙咀
// 	旺角
// 	太子
// 	大角咀
// 	柯士甸
// 元朗區	元朗
// 	天水圍
// 	八鄉
// 	屏山
// 	洪水橋
// 	廈村
// 	新田
// 	錦田
// 長洲區	長洲
// 中西區	中環
// 	上環
// 	西環
// 	堅尼地城
// 	金鐘
// 	半山
// 	西營盤
// 北區	粉嶺
// 	上水
// 	沙頭角
// 	北區
const districts = {
  大埔區: ['大埔'],
  大嶼山區: ['馬灣', '愉景灣', '東涌', '香港國際機場', '大嶼山'],
  東區: [
    '北角',
    '柴灣',
    '筲箕灣',
    '太古',
    '鰂魚涌',
    '西灣河',
    '小西灣',
    '天后',
    '炮台山',
    '杏花邨',
  ],
  觀塘區: ['觀塘', '藍田', '油塘', '九龍灣', '牛頭角', '秀茂坪', '順利'],
  黃大仙區: ['彩虹', '慈雲山', '黃大仙', '新蒲崗', '樂富', '鑽石山', '牛池灣'],
  九龍城區: [
    '紅磡',
    '九龍城',
    '九龍塘',
    '馬頭圍',
    '土瓜灣',
    '何文田',
    '啟德',
    '黃埔',
  ],
  葵青區: ['葵涌', '青衣', '荔景', '葵興', '葵芳'],
  南區: [
    '石澳',
    '赤柱',
    '大潭',
    '香港仔',
    '鴨脷洲',
    '薄扶林',
    '華富',
    '黃竹坑',
  ],
  南丫島區: ['南丫島'],
  坪洲區: ['坪洲'],
  荃灣區: ['荃灣', '深井', '大窩口'],
  沙田區: ['沙田', '大圍', '馬鞍山', '火炭', '九肚山', '小瀝源', '石門'],
  深水埗區: ['長沙灣', '荔枝角', '美孚', '石硤尾', '深水埗', '南昌'],
  屯門區: ['屯門', '小欖', '新墟', '掃管笏', '藍地'],
  灣仔區: ['灣仔', '銅鑼灣', '跑馬地', '大坑'],
  西貢區: ['清水灣', '西貢', '調景嶺', '將軍澳', '坑口', '康城', '寶琳'],
  油尖旺區: ['油麻地', '佐敦', '尖沙咀', '旺角', '太子', '大角咀', '柯士甸'],
  元朗區: ['元朗', '天水圍', '八鄉', '屏山', '洪水橋', '廈村', '新田', '錦田'],
  長洲區: ['長洲'],
  中西區: ['中環', '上環', '西環', '堅尼地城', '金鐘', '半山', '西營盤'],
  北區: ['粉嶺', '上水', '沙頭角', '北區'],
};

export default districts;
